import { render, staticRenderFns } from "./SalesCommissionTrackerOrdersUserTable.vue?vue&type=template&id=33f130e5&scoped=true&"
import script from "./SalesCommissionTrackerOrdersUserTable.vue?vue&type=script&lang=js&"
export * from "./SalesCommissionTrackerOrdersUserTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f130e5",
  null
  
)

export default component.exports